<template>
	<v-app>
		<div class="headers">
			<emb-header-v1></emb-header-v1>
		</div>

		<v-snackbar
			v-for="(snackbar, index) in notifications"
			v-model="snackbar.show"
			:color="snackbar.type"
			:timeout="2000"
			:right="true"
			:top="true"
			:key="index"
		>
			{{ snackbar.message }}
		</v-snackbar>

		<!-- Menu for mobile -->
		<v-navigation-drawer v-model="mobileMenu" temporary absolute dark class="sidebar-bg">
			<emb-sidebar></emb-sidebar>
		</v-navigation-drawer>
		<div style="min-height: calc(100vh - 65px - 182px)">
            <router-view></router-view>
        </div>
		<emb-footer-V1
			title="Sobre la compañía"
			description="Somos una empresa peruana, nos dedicamos al desarrollo de sistemas informáticos a medida, pero, sobre todo a brindar soluciones integrales con tecnología de primer nivel. Mostramos eficiencia, eficacia y responsabilidad social; para incrementar los niveles de productividad y control de tu negocio."
			img="/static/images/cards.png"
		>
		</emb-footer-V1>

		<emb-call></emb-call>
	</v-app>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['notifications']),
		mobileMenu: {
			get() {
				return this.$store.getters.sidebarOpen;
			},
			set(val) {
				this.$store.dispatch('toggleSidebar', val);
			},
		},
	},
	beforeCreate() {
		document.title = 'Facturación Electrónica | Sislii';
	},
};
</script>
